/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll14 } from '../fn/app-reason-group/find-all-14';
import { FindAll14$Params } from '../fn/app-reason-group/find-all-14';
import { ReasonGroup } from '../models/reason-group';

@Injectable({ providedIn: 'root' })
export class AppReasonGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll14()` */
  static readonly FindAll14Path = '/api/values/app-reason-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll14()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll14$Response(params?: FindAll14$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReasonGroup>>> {
    return findAll14(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll14$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll14(params?: FindAll14$Params, context?: HttpContext): Observable<Array<ReasonGroup>> {
    return this.findAll14$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReasonGroup>>): Array<ReasonGroup> => r.body)
    );
  }

}
